import getAppDate from '@ahmdigital/logic/lib/utils/get-app-date';
import getSaleableCombinedProductIdsLib from '@ahmdigital/logic/lib/utils/get-saleable-combined-product-ids';

import config from '../../config';

/**
 * A small wrapper utility to save importing config and getAppDate everywhere.
 */
const getSaleableCombinedProductIds = () => {
  // @ts-expect-error: ahm logic needs to support generic for typeof config
  const appDate = getAppDate(config);
  const saleable = getSaleableCombinedProductIdsLib(appDate);
  return saleable;
};

export default getSaleableCombinedProductIds;
